import { useEffect, useState } from "react";
import { apiClient } from "../api/apiClient.js";

/** Fetches GET /api/backoffice/home - current user, role, access scopes, visible modules, summary counts. */
export function useBackofficeHome() {
  const [state, setState] = useState({ status: "loading", data: null, error: null });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading", data: null, error: null });

    apiClient
      .get("/backoffice/home")
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({ status: "error", data: null, error });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
